"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _pointsMall = require("@/api/pointsMall");
var _applet = require("@/api/operation/applet");
var _permission = require("@/utils/permission");
var _ZBKJIutil = require("@/utils/ZBKJIutil");
var _auth = require("@/utils/auth");
var _product = _interopRequireDefault(require("@/mixins/product"));
var _default2 = require("@/views/marketing/pointsMall/default");
var _creatAttr = _interopRequireDefault(require("../components/creatAttr"));
var _vuex = require("vuex");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'ProductProductAdd',
  directives: {
    // 计算是否滚动到最下面
    selectLoadMore: {
      bind: function bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        var SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          var condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      }
    }
  },
  components: {
    Tinymce: _index.default,
    creatAttr: _creatAttr.default
  },
  mixins: [_product.default],
  data: function data() {
    return {
      formThead: Object.assign({}, _default2.objTitlePoints),
      manyTabTit: {},
      manyTabDate: {},
      // 生成规格表格中的头部标题
      htmlKey: 0,
      headTab: [{
        tit: '商品信息',
        name: '1'
      }, {
        tit: '规格库存',
        name: '2'
      }, {
        tit: '商品详情',
        name: '3'
      }, {
        tit: '评论配置',
        name: '4'
      }],
      form: 2,
      appIdentifierList: [],
      userSourceList: [{
        value: '1',
        label: 'WiFi'
      }, {
        value: '2',
        label: '摄像头'
      }],
      labelarr: [],
      isDisabled: this.$route.params.isDisabled === 'noEdit',
      isChoose: this.$route.params.isChoose === 'choose',
      //是否是选择商品
      isCopy: this.$route.params.isCopy === 'copy',
      //是否是复制商品
      tabs: [],
      props: {
        multiple: true
      },
      active: 0,
      OneattrValue: [Object.assign({}, _default2.defaultObj.attrValueList[0])],
      // 单规格
      ManyAttrValue: [Object.assign({}, _default2.defaultObj.attrValueList[0])],
      // 多规格
      formValidate: JSON.parse(JSON.stringify(_objectSpread(_objectSpread({}, _default2.defaultObj), {}, {
        redPacket: 0,
        appIdentifierList: [],
        userSourceList: []
      }))),
      // tableAttrValue: {}, //商品规格
      grid2: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24
      },
      categoryProps: {
        value: 'id',
        label: 'name',
        children: 'childList',
        expandTrigger: 'hover',
        checkStrictly: false,
        emitPath: false,
        multiple: true
      },
      // 规格数据
      formDynamic: {
        attrsName: '',
        attrsVal: ''
      },
      isBtn: false,
      manyFormValidate: [],
      currentTab: '1',
      isChoice: '',
      grid: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24
      },
      ruleValidate: {
        name: [{
          required: true,
          message: '请输入商品名称',
          trigger: 'blur'
        }],
        unitName: [{
          required: true,
          message: '请输入单位',
          trigger: 'blur'
        }],
        intro: [{
          required: true,
          message: '请输入商品简介',
          trigger: 'blur'
        }],
        tempId: [{
          required: true,
          message: '请选择运费模板',
          trigger: 'change'
        }],
        image: [{
          required: true,
          message: '请上传商品图',
          trigger: 'change'
        }],
        sliderImages: [{
          required: true,
          message: '请上传商品轮播图',
          type: 'array',
          trigger: 'change'
        }],
        specType: [{
          required: true,
          message: '请选择商品规格',
          trigger: 'change'
        }],
        exchangeNum: [{
          required: true,
          message: '请输入兑换数量限制',
          trigger: 'blur'
        }],
        redPacket: [{
          required: true,
          message: '请输入红包抵扣金额',
          trigger: 'blur'
        }, {
          validator: this.validateRedPacket,
          trigger: 'blur'
        }],
        merchantAddressId: [{
          required: true,
          message: '请选择售后地址',
          trigger: 'blur'
        }]
      },
      attrInfo: {},
      tableFrom: {
        page: 1,
        limit: 9999,
        keywords: ''
      },
      tempRoute: {},
      keyNum: 0,
      isShowAttr: false,
      showAll: false,
      search: {
        limit: this.$constants.page.limit[0],
        page: 1,
        cid: '',
        brandName: ''
      },
      totalPage: 0,
      total: 0,
      loading: false,
      loadingBtn: false,
      isShowGroup: false,
      multiples: true,
      productType: [{
        tit: '普通商品',
        id: 0,
        tit2: '实体货物'
      }, {
        tit: '云盘商品',
        id: 5,
        tit2: '同一链接发货'
      }, {
        tit: '卡密商品',
        id: 6,
        tit2: '不同充值码发货'
      }],
      upload: {
        videoIng: false // 是否显示进度条；
      },
      videoLink: '',
      //视频地址
      progress: 10,
      // 进度条默认0
      myHeaders: {
        'X-Token': (0, _auth.getToken)()
      },
      oneFormBatch: [{
        image: '',
        price: void 0,
        redeemIntegral: void 1,
        cost: void 0,
        stock: void 0,
        barCode: '',
        weight: void 0,
        volume: void 0
      }],
      replyHeader: [{
        title: '用户昵称',
        slot: 'nickname',
        width: 120
      }, {
        title: '用户头像',
        slot: 'avatar',
        width: 120
      }, {
        title: '评论内容',
        slot: 'comment',
        width: 120
      }, {
        title: '评论时间',
        slot: 'replyDate',
        width: 120
      }, {
        title: '星级',
        slot: 'star',
        width: 120
      }, {
        title: '评论图片',
        slot: 'pics',
        width: 120
      }]
    };
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.bus.$emit('onTagsViewRefreshRouterView', this.$route.path);
    next();
  },
  computed: _objectSpread({
    visitedViews: function visitedViews() {
      return this.$store.state.tagsView.visitedViews;
    }
  }, (0, _vuex.mapGetters)(['shippingTemplates'])),
  created: function created() {
    this.tempRoute = Object.assign({}, this.$route);
    this.getAppIdentifierList();
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            this.setTagsViewTitle();
            this.$store.dispatch('product/getShippingTemplates');
            this.formValidate.sliderImages = [];
            this.formValidate.attrs = [];
            if (!(this.$route.params.id && this.$route.params.id != 0)) {
              _context.n = 5;
              break;
            }
            if (this.isChoose) {
              _context.n = 2;
              break;
            }
            if (!(0, _permission.checkPermi)(['platform:integral:product:detail'])) {
              _context.n = 1;
              break;
            }
            _context.n = 1;
            return this.getPointsProductInfo(this.$route.params.id);
          case 1:
            _context.n = 4;
            break;
          case 2:
            _context.n = 3;
            return this.getProductInfo(this.$route.params.id);
          case 3:
            this.formThead = Object.assign({}, _default2.objTitlePoints);
            this.getPointsProductAttrValue(); //获取积分商品规格数据
          case 4:
            _context.n = 6;
            break;
          case 5:
            this.isShowAttr = true;
          case 6:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapMutations)('menu', ['closeTag'])), {}, {
    checkPermi: _permission.checkPermi,
    // 回调规格生成表格数据
    changeManyAttrValue: function changeManyAttrValue(e) {
      // rows数组第一项 新增默认数据 oneFormBatch
      this.ManyAttrValue = e;
    },
    changeIsEditVal: function changeIsEditVal() {
      this.isEditAttrVal = false;
    },
    //批量清空规格中的批量数据
    handleBatchDel: function handleBatchDel() {
      this.oneFormBatch = [{
        image: '',
        price: void 0,
        redeemIntegral: void 1,
        cost: void 0,
        stock: void 0,
        barCode: '',
        weight: void 0,
        volume: void 0
      }];
    },
    //视频上传前
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = file.type === 'video/mp4';
      var isLt2M = file.size / 10240 / 10240 < 2;
      if (!isJPG) {
        this.$message.error('上传视频只能是 mp4 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传视频不能超过 20MB!');
      }
      return isJPG && isLt2M;
    },
    // 上传
    handleUploadForm: function () {
      var _handleUploadForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(param) {
        var formData, data, loading, res, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              formData = new FormData();
              data = {
                model: 'product',
                pid: 0
              };
              loading = this.$loading({
                lock: true,
                text: '上传中，请稍候...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              formData.append('multipart', param.file);
              _context2.p = 1;
              _context2.n = 2;
              return (0, _ZBKJIutil.uploadImage)(formData, data);
            case 2:
              res = _context2.v;
              this.upload.videoIng = true;
              this.videoLink = res.url;
              this.progress = 100;
              loading.close();
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              loading.close();
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function handleUploadForm(_x) {
        return _handleUploadForm.apply(this, arguments);
      }
      return handleUploadForm;
    }(),
    // 删除视频；
    delVideo: function delVideo() {
      this.$set(this, 'videoLink', '');
    },
    getAppIdentifierList: function getAppIdentifierList() {
      var _this = this;
      (0, _applet.appletAllListApi)().then(function (res) {
        _this.appIdentifierList = res.map(function (item) {
          var statusTxt = item.status ? '启用' : '禁用';
          item.name = "[".concat(item.appIdentifier, "]").concat(item.appName, "-(").concat(statusTxt, ")");
          return item;
        });
      });
    },
    getLabelarr: function getLabelarr(attr) {
      this.labelarr = attr;
    },
    proving1: function proving1(e) {
      this.formValidate.sort = e.target.value.replace(/[^\.\d]/g, '');
      this.formValidate.sort = e.target.value.replace('.', '');
    },
    setTagsViewTitle: function setTagsViewTitle() {
      if (this.$route.params.id && this.$route.params.id != 0) {
        var title = this.isDisabled ? '商品详情' : '编辑商品';
        var route = Object.assign({}, this.tempRoute, {
          title: "".concat(title, "-").concat(this.$route.params.id)
        });
        this.$store.dispatch('tagsView/updateVisitedView', route);
      } else {
        var _title = '采集商品';
        var _route = Object.assign({}, this.tempRoute, {
          title: "".concat(_title)
        });
        this.$store.dispatch('tagsView/updateVisitedView', _route);
      }
    },
    showInput: function showInput(item) {
      this.$set(item, 'inputVisible', true);
    },
    handleRemove: function handleRemove(i) {
      this.formValidate.sliderImages.splice(i, 1);
    },
    handleAddReplyItem: function handleAddReplyItem() {
      if (this.formValidate.replyInfo.replyList.length < 2) {
        this.formValidate.replyInfo.replyList.push(JSON.parse(JSON.stringify(_default2.defaultReplyValue)));
      }
    },
    handleReplyRemove: function handleReplyRemove(i) {
      this.formValidate.replyInfo.replyList.splice(i, 1);
    },
    handleReplyPicRemove: function handleReplyPicRemove(index, i) {
      this.formValidate.replyInfo.replyList[index].pics.splice(i, 1);
    },
    // 上一步
    handleSubmitUp: function handleSubmitUp() {
      this.currentTab = (Number(this.currentTab) - 1).toString();
    },
    // 下一步
    handleSubmitNest: function handleSubmitNest(name) {
      var _this2 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this2.currentTab = (Number(_this2.currentTab) + 1).toString();
        } else {
          if (!_this2.formValidate.name || !_this2.formValidate.unitName || !_this2.formValidate.intro || !_this2.formValidate.image || !_this2.formValidate.sliderImages) {
            _this2.$message.warning('请填写完整商品信息！');
          }
        }
      });
    },
    //保存接口数据更新
    getFormData: function getFormData() {
      var _this3 = this;
      if (this.formValidate.specType && this.formValidate.attrs.length < 1) return this.$message.warning('请填写多规格属性！');

      // 验证红包抵扣金额
      if (!this.validateRedPacketAmount()) {
        return false;
      }
      this.formValidate.keyword = this.labelarr.join(',');
      if (this.videoLink) {
        //如果有视频主图，将视频链接插入到轮播图第一的位置
        this.formValidate.sliderImages.unshift(this.videoLink);
      }
      this.formValidate.sliderImage = JSON.stringify(this.formValidate.sliderImages);
      var attrValueListData = [];
      if (this.formValidate.specType) {
        //规格值
        this.formValidate.attrList = this.formValidate.attrs.map(function (item, index) {
          return {
            attributeName: item.value,
            isShowImage: item.add_pic == 1 ? true : false,
            id: 0,
            sort: index + 1,
            optionList: item.detail.map(function (arr, idx) {
              return {
                image: arr.image,
                optionName: arr.value,
                sort: idx + 1
              };
            })
          };
        });
        //表格数据
        var ManyAttrValues = _toConsumableArray(this.ManyAttrValue);
        attrValueListData = ManyAttrValues;
        attrValueListData.shift();
        for (var i = 0; i < attrValueListData.length; i++) {
          var attrValues = _objectSpread({}, attrValueListData[i].attrValueShow);
          this.$set(attrValueListData[i], 'attrValue', JSON.stringify(attrValues)); //
        }
      } else {
        this.formValidate.attrList = [{
          attributeName: '规格',
          attrValues: '默认',
          isShowImage: false,
          optionList: [{
            optionName: '默认',
            id: 0,
            image: '',
            sort: 1
          }]
        }];
        this.OneattrValue.map(function (item) {
          _this3.$set(item, 'attrValue', JSON.stringify({
            规格: '默认'
          }));
        });
      }
      var data = _objectSpread(_objectSpread({}, this.formValidate), {}, {
        cateId: this.formValidate.cateIds.join(','),
        keyword: this.labelarr.join(','),
        sliderImage: JSON.stringify(this.formValidate.sliderImages),
        deliveryMethod: 1,
        systemFormId: this.formValidate.systemFormId ? this.formValidate.systemFormId : 0,
        attrValueList: this.formValidate.specType ? attrValueListData : this.OneattrValue,
        appIdentifier: this.formValidate.appIdentifierList.join(','),
        userSource: this.formValidate.userSourceList.join(',')
      });
      return data;
    },
    // 保存
    handleSubmit: function handleSubmit(name) {
      var _this4 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          //this.getFormData();
          _this4.postData();
        } else {
          if (!_this4.formValidate.name || !_this4.formValidate.cateId || !_this4.formValidate.keyword || !_this4.formValidate.unitName || !_this4.formValidate.intro || !_this4.formValidate.image || !_this4.formValidate.sliderImages) {
            _this4.$message.warning('请填写完整商品信息！');
          }
        }
      });
    },
    // 新增保存数据
    postData: function postData() {
      var _this5 = this;
      this.loadingBtn = true;
      var data = this.getFormData();
      parseFloat(this.$route.params.id) > 0 && !this.isChoose && !this.isCopy ? (0, _pointsMall.productUpdateApi)(data).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(res) {
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                _this5.$message.success('编辑成功');
                setTimeout(function () {
                  _this5.$router.push({
                    path: '/marketing/pointsMall/productManage'
                  });
                }, 500);
                _this5.closeSelectedTag();
                _this5.loadingBtn = false;
              case 1:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this5.loadingBtn = false;
        // for (var i = 0; i < this.formValidate.attrValue.length; i++) {
        //   let attrValues = this.formValidate.attrValue[i].attrValue;
        //   this.$set(this.formValidate.attrValue[i], 'attrValue', JSON.parse(attrValues));
        // }
        // if (this.formValidate.specType) this.ManyAttrValue = this.formValidate.attrValue;
      }) : (0, _pointsMall.productCreateApi)(data).then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(res) {
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                _this5.$message.success('新增成功');
                setTimeout(function () {
                  _this5.$router.push({
                    path: '/marketing/pointsMall/productManage'
                  });
                }, 500);
                _this5.closeSelectedTag();
                _this5.loadingBtn = false;
              case 1:
                return _context4.a(2);
            }
          }, _callee4);
        }));
        return function (_x3) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this5.loadingBtn = false;
        // for (var i = 0; i < this.formValidate.attrValue.length; i++) {
        //   let attrValues = this.formValidate.attrValue[i].attrValue;
        //   this.$set(this.formValidate.attrValue[i], 'attrValue', JSON.parse(attrValues));
        // }
        // if (this.formValidate.specType) this.ManyAttrValue = this.formValidate.attrValue;
      });
    },
    isActive: function isActive(route) {
      return route.path === this.$route.path;
    },
    closeSelectedTag: function closeSelectedTag() {
      var _this6 = this;
      var route = this.$route;
      this.$store.dispatch('tagsView/delView', route).then(function (_ref3) {
        var visitedViews = _ref3.visitedViews;
        if (_this6.isActive(route)) {
          _this6.closeTag(route);
          _this6.$router.push({
            path: '/marketing/pointsMall/productManage'
          });
          // this.toLastView(visitedViews, route);
        }
      });
    },
    toLastView: function toLastView(visitedViews, view) {
      var latestView = visitedViews.slice(-1)[0];
      if (latestView) {
        this.$router.push(latestView.fullPath);
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'Dashboard') {
          // to reload home page
          this.$router.replace({
            path: '/redirect' + view.fullPath
          });
        } else {
          this.$router.push('/');
        }
      }
    },
    // 表单验证
    validate: function validate(prop, status, error) {
      if (status === false) {
        this.$message.warning(error);
      }
    },
    // 验证红包抵扣金额
    validateRedPacket: function validateRedPacket(rule, value, callback) {
      if (value === undefined || value === null || value === '') {
        callback(new Error('请输入红包抵扣金额'));
        return;
      }
      if (value < 0) {
        callback(new Error('红包抵扣金额不能小于0'));
        return;
      }

      // 获取所有规格的兑换金额
      var exchangeAmounts = [];
      if (this.formValidate.specType) {
        // 多规格 - 从第二列开始获取价格
        exchangeAmounts = this.ManyAttrValue.slice(1).map(function (item) {
          return item.price || 0;
        });
      } else {
        // 单规格
        exchangeAmounts = [this.OneattrValue[0].price || 0];
      }

      // 检查是否小于所有兑换金额
      var isValid = exchangeAmounts.every(function (amount) {
        return value <= amount;
      });
      if (!isValid) {
        callback(new Error('红包抵扣金额必须小于等于所有规格的兑换金额'));
        return;
      }
      callback();
    },
    // 验证红包抵扣金额
    validateRedPacketAmount: function validateRedPacketAmount() {
      var redPacket = this.formValidate.redPacket;
      if (redPacket === undefined || redPacket === null || redPacket === '') {
        this.$message.warning('请输入红包抵扣金额');
        return false;
      }
      if (redPacket < 0) {
        this.$message.warning('红包抵扣金额不能小于0');
        return false;
      }

      // 获取所有规格的兑换金额
      var exchangeAmounts = [];
      if (this.formValidate.specType) {
        // 多规格 - 从第二列开始获取价格
        exchangeAmounts = this.ManyAttrValue.slice(1).map(function (item) {
          return item.price || 0;
        });
      } else {
        // 单规格
        exchangeAmounts = [this.OneattrValue[0].price || 0];
      }

      // 检查是否小于所有兑换金额
      var isValid = exchangeAmounts.every(function (amount) {
        return redPacket <= amount;
      });
      if (!isValid) {
        this.$message.warning('红包抵扣金额必须小于所有规格的兑换金额');
        return false;
      }
      return true;
    }
  })
};